import React, { useState } from "react";
import PropTypes from "prop-types";
import Transition from "./Transition.js";

function NavBarDropdown({ theme = "light", children, title, link }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  let classNameLink =
    "text-rhoGray-500 hover:text-rhoGray-900 px-3 lg:px-5 py-2 flex items-center transition duration-150 ease-in-out h-full";
  let classNameSvg =
    "w-3 h-3 fill-current text-rhoGray-500 cursor-pointer ml-1 flex-shrink-0";
  let classNameDropdownContainer =
    "absolute top-20 left-0 w-full bg-rhoOffWhite-100 rounded shadow-lg";

  if (theme === "dark") {
    classNameLink =
      "text-rhoGray-100 hover:text-rhoGray-200 px-3 lg:px-5 py-2 flex items-center transition duration-150 ease-in-out h-full";
    classNameSvg =
      "w-3 h-3 fill-current text-rhoGray-100 cursor-pointer ml-1 flex-shrink-0";
    classNameDropdownContainer =
      "absolute top-20 left-0 w-full bg-rhoOffWhite-100 rounded shadow-lg";
  }

  return (
    <li
      className="h-full"
      onMouseEnter={() => setDropdownOpen(true)}
      onMouseLeave={() => setDropdownOpen(false)}
      onFocus={() => setDropdownOpen(true)}
      onBlur={() => setDropdownOpen(false)}
    >
      <a
        className={classNameLink}
        href={link ? link : "#0"}
        aria-expanded={dropdownOpen}
        onClick={link ? null : (e) => e.preventDefault()}
      >
        {title}
        &nbsp;
        <i
          className={
            dropdownOpen ? "fa-thin fa-chevron-up" : "fa-thin fa-chevron-down"
          }
        ></i>
      </a>
      <Transition
        show={dropdownOpen}
        className={classNameDropdownContainer}
        enter="transition ease-out duration-200 transform"
        enterStart="opacity-0 -translate-y-2"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-out duration-200"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
      >
        {children}
      </Transition>
    </li>
  );
}

export default NavBarDropdown;

NavBarDropdown.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element.isRequired,
  ]),
  title: PropTypes.string.isRequired,
};
